  import React, { useEffect, useState, memo, Fragment } from "react";
  import { Container, Row, Col, Card } from "react-bootstrap";
  import {
    BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, PieChart,
    Pie, Cell
  } from 'recharts';
  import {
    FaUserShield,
    FaBuilding,
    FaUserTie,
    FaUserFriends,
    FaBullhorn,
    FaCalendarAlt
} from "react-icons/fa";
  import AsyncStorage from '@react-native-async-storage/async-storage';
  import { FaUser, FaUsers, FaClock, FaStopwatch, FaHourglassHalf, FaChartLine, FaChartPie, FaPercentage, FaDatabase, FaPhone, FaPhoneAlt, FaPhoneVolume, FaPhoneSlash, FaCog, FaPhoneSquareAlt, FaChartBar } from 'react-icons/fa';
  import { getApiCall } from '../../service/httpCall';
  import { API_AGENTS_LIST,API_AGENT_SCHEDULE, API_ALL_INCOMING_REPORT, API_INCOMING_SUMMARY_LIST, API_OUTGOING_CALLS, API_DASHBOARD_STATS } from '../../service/url';
  import "bootstrap/dist/css/bootstrap.min.css";
  import { TelephoneFill } from "react-bootstrap-icons";
  import { ROUTES } from "../../utilities/constant";
  import { useNavigate } from "react-router-dom";
  // import DashboardButtons from "../../views/dashboard/desposition/DashboardButtons";
  import FloatingPanels from "../../views/dashboard/desposition/FloatingPanels";
  import { Doughnut } from "react-chartjs-2";
  import { Calendar } from "primereact/calendar";
  import "../../assets/custom/css/dash.css"
  // AOS
  import AOS from "aos";
  import "../../../node_modules/aos/dist/aos";
  import "../../../node_modules/aos/dist/aos.css";

  import SwiperCore, { Navigation } from "swiper";
  import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

  // Import Swiper styles
  import "swiper/swiper-bundle.min.css";
  // import 'swiper/components/navigation/navigation.scss';

  // Redux Selector / Action
  import { useSelector } from "react-redux";

  // Import selectors & action from setting store
  import * as SettingSelector from "../../store/setting/selectors";

  import { USER_ROLES } from '../../utilities/constant';
  import Chart from "react-apexcharts"
  import { Button } from "primereact/button";
  import { toast } from "react-toastify";
  import DashboardCampaignDetails from "./dashboard-campaign-details";
  import PendingPromptsTable from "./pending-prompts";

  // install Swiper modules
  SwiperCore.use([Navigation]);

  const Index = memo((props) => {
    const [isSuperAdmin, setIsSuperAdmin] = useState(false);
    const [isReseller, setIsReseller] = useState(false);
    const [graph, setGraph] = useState([]);
    const [isCompanyAdmin, setCompanyAdmin] = useState(false);
    const [isCallCenterAdmin, setCallCenterAdmin] = useState(false);
    const [isCallCenterAgent, setCallCenterAgent] = useState(false);
    const [ToggleincomingBarChart, setToggleincomingBarChart] = useState(false);
    const [ToggleOutgoingBarChart, setToggleOutgoingBarChart] = useState(false);
    const [ToggleAgentBarChart, setToggleAgentBarChart] = useState(false);
    const [ToggleAgentPieChart, setToggleAgentPieChart] = useState(true);
    const [agentId, setAgentId] = useState(null);
    const [agentGroups, setAgentGroups] = useState([]); // list of groups for that agent
    const [showQueueTooltip, setShowQueueTooltip] = useState(false); // hover state
    const [queuePage, setQueuePage] = useState(0);
    const [dashboardStats, setDashboardStats] = useState(null);
const pageSize = 2;
const totalPages = Math.ceil(agentGroups.length / pageSize);


    const [IncomingstartDate, setIncomingStartDate] = useState(null)
    const [IncomingendDate, setIncomingEndDate] = useState(null)

    const [startDate, setStartDate] = useState(null)
    const [endDate, setEndDate] = useState(null)

    const [AgentStartDate, setAgentStartDate] = useState(null)
    const [AgentEndDate, setAgentEndDate] = useState(null)

    const [OutgoingstartDate, setOutgoingStartDate] = useState(null)
    const [OutgoingendDate, setOutgoingEndDate] = useState(null)

    const [agentDataObject, setAgentDataObject] = useState({
      total_agent: 0,
      logged_in_agent: 0,
      agent_on_call: 0
    });
    const [incomingSummaryData, setIncomingSummaryData] = useState({
      dialed_call: 0,
      answered_call: 0,
    });

    const [InboundReportData, setInboundReportData] = useState({
      abandoned_calls: 0,
    })

    const [outgoingCallsData, setOutgoingCallsData] = useState({
      total_calls: 0,
      dialed_call: 0,
      answered_call: 0,
    })

    const [shake, setShake] = useState(false);
    const navigate = useNavigate();


    const handleToggleChat = () => {
      navigate(`/${ROUTES.REMARKS.REMARKS}`);
    };

    const handleToggleDisposition = () => {
      navigate(`/${ROUTES.DESPOSITION.ADD}`);
    };


    useEffect(() => {
      const interval = setInterval(() => {
        setShake(true);
        setTimeout(() => setShake(false), 500);
      }, 2700);
      return () => clearInterval(interval);
    }, []);

    useEffect(() => {
  if (showQueueTooltip) setQueuePage(0);
}, [showQueueTooltip]);


const paginatedGroups = agentGroups.slice(
  queuePage * pageSize,
  queuePage * pageSize + pageSize
);

const hasPrev = queuePage > 0;
const hasNext = queuePage < totalPages - 1;


    useEffect(() => {
      async function checkUserRole() {
        const rawUser = await AsyncStorage.getItem('user');
        if (!rawUser) {
          console.error("User not found in AsyncStorage");
          return null; // or handle as needed
        }

        let user;
        try {
          user = JSON.parse(rawUser);
        } catch (e) {
          console.error("Invalid JSON in user from AsyncStorage", e);
          return null;
        }
        if (user.role === USER_ROLES.SUPERADMIN) setIsSuperAdmin(true);
      }
      checkUserRole();
    }, []);

    const doughnutAgentsData = {
      labels: ["Total Agents", "Logged In Agents", "Agents On Call"],
      datasets: [
        {
          data: [(Number(agentDataObject?.total_agent) || 0), (Number(agentDataObject?.logged_in_agent) || 0), (Number(agentDataObject?.agent_on_call) || 0)],
          backgroundColor: ["#2ebf3f", "#eb173b", "#1761ebff"],
          borderWidth: 0,
        },
      ],
    };

    const doughnutIncomingData = {
      labels: ["Dialed Calls", "Answered Calls", "Abandoned Calls"],
      datasets: [
        {
          data: [(Number(incomingSummaryData.dialed_call) || 0), (Number(incomingSummaryData.answered_call) || 0), (Number(InboundReportData.abandoned_calls) || 0)],
          backgroundColor: ["#e45604ff", "rgba(53, 214, 220, 1)", "rgb(156, 39, 176)"],
          borderWidth: 0,
        },
      ],
    };

    const doughnutOutgoingData = {
      labels: ["Total Calls", "Dialed Calls", "Answered Calls"],
      datasets: [
        {
          data: [(Number(outgoingCallsData?.total_calls) || 0), (Number(outgoingCallsData?.dialed_call) || 0), (Number(outgoingCallsData?.answered_call) || 0)],
          backgroundColor: ["#f00054ff", "#d2cc1bff", "#28927bff"],
          borderWidth: 0,
        },
      ],
    };

    const doughnutAgentOutgoingData = {
      labels: ["Total Calls", "Dialed Calls", "Answered Calls"],
      datasets: [
        {
          data: [(Number(outgoingCallsData?.total_calls) || 0), (Number(outgoingCallsData?.dialed_call) || 0), (Number(outgoingCallsData?.answered_call) || 0)],
          backgroundColor: ["#f00054ff", "#d2cc1bff", "#28927bff"],
          borderWidth: 0,
        },
      ],
    };

    const doughnutOptions = {
      cutout: "50%",
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: false,
        },
        font: {
            size: 24
          },
      },
    };



    const barIncomingData = {
      series: [
        {
          name: "Calls",
          data: [
            Number(incomingSummaryData.dialed_call) || 0,
            Number(incomingSummaryData.answered_call) || 0,
            Number(InboundReportData.abandoned_calls) || 0
          ],
        },
      ],
      options: {
        chart: {
          type: "bar",
          toolbar: { show: false },
        },
        grid: {
          padding: {
            top: -20,
            bottom: 60, // pull chart up
            left: 0,
            right: 0,
          },
        },
        plotOptions: {
          bar: {
            distributed: true,
            columnWidth: "40%", // makes bars slimmer/fatter
          },
        },
        xaxis: {
          categories: ["Dialed Calls", "Answered Calls", "Abandoned Calls"],
          labels: {
            show: false,
          },
        },
        yaxis: {
          labels: {
            offsetX: -10, // move numbers left or right
            style: {
              fontSize: '12px',
              fontWeight: 500,
            }
          }
        },
        legend: {
          show: false,
        },
        colors: ["#e45604", "#35d6dc", "#9c27b0"],
      },
    };

    const barOutgoingData = {
      series: [
        {
          name: "Calls",
          data: [
            Number(outgoingCallsData?.total_calls) || 0,
            Number(outgoingCallsData?.dialed_call) || 0,
            Number(outgoingCallsData?.answered_call) || 0
          ],
        },
      ],
      options: {
        chart: {
          type: "bar",
          toolbar: { show: false },
        },
        grid: {
          padding: {
            top: -20,
            bottom: 60, // same as incoming
            left: 0,
            right: 0,
          },
        },
        plotOptions: {
          bar: {
            distributed: true,
            columnWidth: "40%",
          },
        },
        xaxis: {
          categories: ["Total Calls", "Dialed Calls", "Answered Calls"],
          labels: {
            show: false,
          },
        },
        yaxis: {
          labels: {
            offsetX: -10, // space between numbers & grid lines
            style: {
              fontSize: '12px',
              fontWeight: 500,
            }
          }
        },
        legend: {
          show: false,
        },
        colors: ["#f00054ff", "#d2cc1bff", "#28927bff"], // from doughnutOutgoingData
      },
    };

    const barAgentsData = {
      series: [
        {
          name: "Agents",
          data: [
            Number(agentDataObject?.total_agent) || 0,
            Number(agentDataObject?.logged_in_agent) || 0,
            Number(agentDataObject?.agent_on_call) || 0
          ],
        },
      ],
      options: {
        chart: {
          type: "bar",
          toolbar: { show: false },
        },
        grid: {
          padding: {
            top: -20,
            bottom: 60,
            left: 0,
            right: 0,
          },
        },
        plotOptions: {
          bar: {
            distributed: true,
            columnWidth: "40%",
          },
        },
        xaxis: {
          categories: ["Total Agents", "Logged In Agents", "Agents On Call"],
          labels: {
            show: false,
          },
        },
        yaxis: {
          labels: {
            offsetX: -10,
            style: {
              fontSize: '12px',
              fontWeight: 500,
            }
          }
        },
        legend: {
          show: false,
        },
        colors: ["#2ebf3f", "#eb173b", "#1761ebff"], // matching doughnut chart
      },
    };

    const fetchDashboardData = async () => {
      try {
        const res = await getApiCall(API_DASHBOARD_STATS);
        setDashboardStats(res);
      } catch (error) {
        toast.error(error?.message || "Error Fetching Dashboard Stats");
      }
    }

    useEffect(() => {
      if (!isSuperAdmin) {
        return;
      }
      fetchDashboardData();
    }, [isSuperAdmin]);



useEffect(() => {
  if (!agentId) return; 

  const fetchAgentGroups = async () => {
    try {
      const resp = await getApiCall(`${API_AGENT_SCHEDULE}/${agentId}`);

      console.log("RESPONSE", resp.groups);
      if (
        resp
      ) {
        console.log("LENGTH", resp.groups);
        setAgentGroups(resp.groups);
      } else {
        setAgentGroups([]);
      }
    } catch (err) {
      console.error("Error fetching agent schedule:", err);
      setAgentGroups([]);
    }
  };

  fetchAgentGroups();
}, [agentId]);




    useEffect(() => {
      async function superadminCheck() {
        const rawUser = await AsyncStorage.getItem('user');
        if (!rawUser) {
          console.error("User not found in AsyncStorage");
          return null; // or handle as needed
        }

        let user;
        try {
          user = JSON.parse(rawUser);
        } catch (e) {
          console.error("Invalid JSON in user from AsyncStorage", e);
          return null;
        }
        if (user.role === USER_ROLES.SUPERADMIN) {
          setIsSuperAdmin(true);
        }
        if (user.role === USER_ROLES.COMPANY_ADMIN) {
          setCompanyAdmin(true);
        }
        if (user.role === USER_ROLES.CALL_CENTRE_ADMIN) {
          setCallCenterAdmin(true);
        }
        if (user.role === USER_ROLES.CALL_CENTRE_AGENT) {
          setCallCenterAgent(true)
          setAgentId(user.agentData?.id|| null)
        }
      }
      async function resellerCheck() {
        const rawUser = await AsyncStorage.getItem('user');
        if (!rawUser) {
          console.error("User not found in AsyncStorage");
          return null; // or handle as needed
        }

        let user;
        try {
          user = JSON.parse(rawUser);
        } catch (e) {
          console.error("Invalid JSON in user from AsyncStorage", e);
          return null;
        }
        if (user.role === USER_ROLES.RESELLER) {
          setIsReseller(true);
        }
      }
      superadminCheck();
      resellerCheck();
    }, []);

    useEffect(() => {
      async function superadminCheck() {
        const rawUser = await AsyncStorage.getItem('user');
        if (!rawUser) {
          console.error("User not found in AsyncStorage");
          return null; // or handle as needed
        }

        let user;
        try {
          user = JSON.parse(rawUser);
        } catch (e) {
          console.error("Invalid JSON in user from AsyncStorage", e);
          return null;
        }
        if (user.role === USER_ROLES.SUPERADMIN) {
          setIsSuperAdmin(true);
        }
        if (user.role === USER_ROLES.COMPANY_ADMIN) {
          setCompanyAdmin(true);
        }
        if (user.role === USER_ROLES.CALL_CENTRE_ADMIN) {
          setCallCenterAdmin(true);
        }
      }

      async function resellerCheck() {
        const rawUser = await AsyncStorage.getItem('user');
        if (!rawUser) {
          console.error("User not found in AsyncStorage");
          return null; // or handle as needed
        }

        let user;
        try {
          user = JSON.parse(rawUser);
        } catch (e) {
          console.error("Invalid JSON in user from AsyncStorage", e);
          return null;
        }
        if (user.role === USER_ROLES.RESELLER) {
          setIsReseller(true);
        }
      }
      superadminCheck();
      resellerCheck();
    }, []);

    const fetchAgents = () => {
      getApiCall(API_AGENTS_LIST)
        .then((resp) => {
          // console.log('resprespresprespresp', resp)
          if (resp && Array.isArray(resp)) {
            const total_agent = resp.length;
            const logged_in_agent = resp.filter(agent => agent.login_status === "1").length;
            const agent_on_call = resp.filter(agent => agent.call_status === "1").length;
            setAgentDataObject({ total_agent, logged_in_agent, agent_on_call });
          }
        })
        .catch((error) => {
          console.log(error)
        })
    };

    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };


    // const handleFilter = () => {
    //   if (!IncomingstartDate || !IncomingendDate) {
    //     console.warn("Please select both start and end dates");
    //     return;
    //   }

    //   const formattedStart = formatDate(IncomingstartDate);
    //   const formattedEnd = formatDate(IncomingendDate);

    //   getApiCall(`${API_INCOMING_SUMMARY_LIST}/date-range?startDate=${formattedStart}&endDate=${formattedEnd}`)
    //     .then((resp) => {

    //       if (resp && Array.isArray(resp)) {
    //         const dialed_call = resp.reduce((sum, item) => sum + Number(item.nos_processed || 0), 0);
    //         const answered_call = resp.reduce((sum, item) => sum + Number(item.connected_calls || 0), 0);

    //         setIncomingSummaryData({ dialed_call, answered_call });
    //       }
    //     })
    //     .catch((error) => {
    //       console.error("Error fetching filtered data:", error);
    //     });
    // };

    const handleAgentFilter = () => {
      if (!AgentStartDate || !AgentEndDate) {
        console.warn("Please select both start and end dates");
        return;
      }

      const formattedStart = formatDate(AgentStartDate);
      const formattedEnd = formatDate(AgentEndDate);

      const url = `${API_OUTGOING_CALLS}?startDate=${formattedStart}&endDate=${formattedEnd}`;

      getApiCall(url)
        .then((resp) => {
          console.log("Filtered Response new", resp);
          if (resp && Array.isArray(resp)) {
            const dialed_call = resp.filter(item => Number(item.billing_duration) > 0).length;
            const answered_call = resp.filter(item => Number(item.patch_duration) > 0).length;

            setOutgoingCallsData({
              total_calls: resp.length,
              dialed_call,
              answered_call
            });
          }
        })
        .catch((error) => {
          console.error(error);
        });
    };

    const handleFilter = () => {
    if (!startDate || !endDate) {
      console.warn("Please select both start and end dates");
      return;
    }

    const formattedStart = formatDate(startDate);
    const formattedEnd = formatDate(endDate);

    // --- Incoming API ---
    const incomingUrl = `${API_INCOMING_SUMMARY_LIST}/date-range?startDate=${formattedStart}&endDate=${formattedEnd}`;
    const incomingPromise = getApiCall(incomingUrl)
      .then((resp) => {
        console.log("RESPO FOR INCOM",resp);
        if (resp && Array.isArray(resp)) {
          const dialed_call = resp.reduce((sum, item) => sum + Number(item.nos_processed || 0), 0);
          const answered_call = resp.reduce((sum, item) => sum + Number(item.connected_calls || 0), 0);
          setIncomingSummaryData({ dialed_call, answered_call });
        }
      });

    // --- Outgoing API ---
    const outgoingUrl = `${API_OUTGOING_CALLS}?startDate=${formattedStart}&endDate=${formattedEnd}`;
    const outgoingPromise = getApiCall(outgoingUrl)
      .then((resp) => {

        console.log("RESPO FOR OUTGOI", resp);
        if (resp && Array.isArray(resp)) {
          const dialed_call = resp.filter(item => Number(item.billing_duration) > 0).length;
          const answered_call = resp.filter(item => Number(item.patch_duration) > 0).length;
          setOutgoingCallsData({
            total_calls: resp.length,
            dialed_call,
            answered_call
          });
        }
      });

    // Run both APIs in parallel
    Promise.all([incomingPromise, outgoingPromise])
      .catch((error) => console.error("Error fetching data:", error));
  };



    // const handleOutgoingDataFilter = () => {
    //   if (!OutgoingstartDate || !OutgoingendDate) {
    //     console.warn("Please select both start and end date.");
    //     return;
    //   }

    //   const formattedStartDate = formatDate(OutgoingstartDate);
    //   const formattedEndDate = formatDate(OutgoingendDate);

    //   const url = `${API_OUTGOING_CALLS}?startDate=${formattedStartDate}&endDate=${formattedEndDate}`;

    //   getApiCall(url)
    //     .then((resp) => {
    //       console.log("Filtered Response new", resp);
    //       if (resp && Array.isArray(resp)) {
    //         const dialed_call = resp.filter(item => Number(item.billing_duration) > 0).length;
    //         const answered_call = resp.filter(item => Number(item.patch_duration) > 0).length;

    //         setOutgoingCallsData({
    //           total_calls: resp.length,
    //           dialed_call,
    //           answered_call
    //         });
    //       }
    //     })
    //     .catch((error) => {
    //       console.error(error);
    //     });
    // };


    // const fetchIncomingSummary = () => {
    //   getApiCall(API_INCOMING_SUMMARY_LIST)
    //     .then((resp) => {
    //       // console.log('resprespresprespresp', resp)
    //       if (resp && Array.isArray(resp)) {
    //         // Summing up the required fields
    //         const dialed_call = resp.reduce((sum, item) => sum + Number(item.nos_processed || 0), 0);
    //         const answered_call = resp.reduce((sum, item) => sum + Number(item.connected_calls || 0), 0);

    //         // Updating the state
    //         setIncomingSummaryData({ dialed_call, answered_call });
    //       }
    //     })
    //     .catch((error) => {
    //       console.log(error)
    //     })
    // };



    const fetchIncomingSummary = () => {
      const today = new Date().toISOString().split("T")[0]; // YYYY-MM-DD format

      getApiCall(`${API_INCOMING_SUMMARY_LIST}/date-range?startDate=${today}&endDate=${today}`)
        .then((resp) => {
          if (resp && Array.isArray(resp)) {
            const dialed_call = resp.reduce((sum, item) => sum + Number(item.nos_processed || 0), 0);
            const answered_call = resp.reduce((sum, item) => sum + Number(item.connected_calls || 0), 0);

            setIncomingSummaryData({ dialed_call, answered_call });
          }
        })
        .catch((error) => {
          console.error("Error fetching today’s data:", error);
        });
    };


    const fetchOutgoingCallsData = () => {
      const today = new Date();

      // helper to format date as YYYY-MM-DD
      const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      };

      const formattedStartDate = `${formatDate(today)}`;
      const formattedEndDate = `${formatDate(today)}`;

      const url = `${API_OUTGOING_CALLS}?startDate=${formattedStartDate}&endDate=${formattedEndDate}`;

      getApiCall(url)
        .then((resp) => {
          if (resp && Array.isArray(resp)) {
            const dialed_call = resp.filter(item => Number(item.billing_duration) > 0).length;
            const answered_call = resp.filter(item => Number(item.patch_duration) > 0).length;

            setOutgoingCallsData({
              total_calls: resp.length,
              dialed_call,
              answered_call
            });
          }
        })
        .catch((error) => {
          console.error("Error fetching today's outgoing calls", error);
        });
    };


    const fetchIncomingReports = () => {
      const today = new Date().toISOString().split("T")[0]; // "2025-08-22"

      getApiCall(`${API_ALL_INCOMING_REPORT}/${today}/${today}`)
        .then((resp) => {
          if (resp) {
            setInboundReportData({
              abandoned_calls: resp.abandoned_calls
            });
          }
        })
        .catch((error) => {
          console.log("Error fetching Inbound Report Data", error);
        });
    };
    useEffect(
      fetchAgents,
      []);

    useEffect(
      fetchIncomingSummary,
      []);

    useEffect(
      fetchOutgoingCallsData,
      []);

    useEffect(
      fetchIncomingReports,
      []);

    let data = [];

    let agentData = [];
    let incommingData = [];
    let outgoingData = [];
    let queueData = [];
    let othersData = [];




    if (isCallCenterAdmin || isSuperAdmin || isCompanyAdmin || isReseller) {

      agentData = [
        { title: 'Total Agents', value: agentDataObject.total_agent, icon: <FaUser />, bgColor: '#4caf50', backgroundImage: 'url(/path/to/total-agents-bg.png)' },
        { title: 'Logged-in Agents', value: agentDataObject.logged_in_agent, icon: <FaStopwatch />, bgColor: '#f44336', backgroundImage: 'url(/path/to/total-agents-bg.png)' },
        { title: 'Agents on Call', value: agentDataObject.agent_on_call, icon: <FaPhoneVolume />, bgColor: '#ff9800', backgroundImage: 'url(/path/to/total-agents-bg.png)' },
      ];
      incommingData = [
        { title: 'Dialed Calls', value: incomingSummaryData.dialed_call, icon: <FaPhone />, bgColor: '#4caf7e', backgroundImage: 'url(/path/to/dialed-call-bg.png)' },
        { title: 'Answered Calls', value: incomingSummaryData.answered_call, icon: <FaPhoneVolume />, bgColor: '#4caf50', backgroundImage: 'url(/path/to/answered-call-bg.png)' },
        { title: 'Abandoned Calls', value: InboundReportData.abandoned_calls, icon: <FaPhoneSlash />, bgColor: '#ff9800', backgroundImage: 'url(/path/to/abandoned-call-bg.png)' }
      ];
      outgoingData = [
        { title: 'Total Calls', value: outgoingCallsData.total_calls, icon: <FaDatabase />, bgColor: '#2196f3', backgroundImage: 'url(/path/to/total-data-bg.png)' },
        { title: 'Dialed Calls', value: outgoingCallsData.dialed_call, icon: <FaPhone />, bgColor: '#4caf7e', backgroundImage: 'url(/path/to/dialed-call-bg.png)' },
        { title: 'Answered Calls', value: outgoingCallsData.answered_call, icon: <FaPhoneVolume />, bgColor: '#ff9800', backgroundImage: 'url(/path/to/answered-call-bg.png)' },
      ];

      queueData = [
        { title: 'AQT', value: '0', icon: <FaUsers />, bgColor: '#3f51b5', backgroundImage: 'url(/path/to/aqt-bg.png)' },
        { title: 'AHT', value: '0', icon: <FaStopwatch />, bgColor: '#f44336', backgroundImage: 'url(/path/to/aht-bg.png)' },
        { title: 'ASA', value: '00:00', icon: <FaHourglassHalf />, bgColor: '#ff9800', backgroundImage: 'url(/path/to/asa-bg.png)' },
        { title: 'SLA', value: '0%', icon: <FaPercentage />, bgColor: '#9c27b0', backgroundImage: 'url(/path/to/sla-bg.png)' },
        { title: 'Agent Disposed', value: '0', icon: <FaUser />, bgColor: '#4cabaf', backgroundImage: 'url(/path/to/system-disposed-bg.png)' },
        { title: 'System Disposed', value: '0', icon: <FaCog />, bgColor: '#f44336', backgroundImage: 'url(/path/to/system-disposed-bg.png)' },
      ];

      othersData = [
        { title: 'Average Wrap-up', value: '00:00', icon: <FaClock />, bgColor: '#795548', backgroundImage: 'url(/path/to/avg-wrapup-bg.png)' },
        { title: 'Offered-Call', value: '0', icon: <FaPhoneAlt />, bgColor: '#ff5722', backgroundImage: 'url(/path/to/offered-call-bg.png)' },
        { title: 'Dialed Data', value: '0', icon: <FaDatabase />, bgColor: '#4caf50', backgroundImage: 'url(/path/to/dialed-data-bg.png)' },
        { title: 'Pending Data', value: '0', icon: <FaPhoneSquareAlt />, bgColor: '#03a9f4', backgroundImage: 'url(/path/to/pending-data-bg.png)' },
        { title: 'Pending Callbacks', value: '0', icon: <FaHourglassHalf />, bgColor: '#ff9800', backgroundImage: 'url(/path/to/pending-callback-bg.png)' },
        { title: 'Con.Dialed Calls', value: '0', icon: <FaPhoneVolume />, bgColor: '#ff9800', backgroundImage: 'url(/path/to/connected-dialed-call-bg.png)' },
      ];

    }
    else {
      outgoingData = [
        { title: 'Total Calls', value: outgoingCallsData.total_calls, icon: <FaDatabase />, bgColor: '#2196f3', backgroundImage: 'url(/path/to/total-data-bg.png)' },
        { title: 'Dialed Calls', value: outgoingCallsData.dialed_call, icon: <FaPhone />, bgColor: '#4caf7e', backgroundImage: 'url(/path/to/dialed-call-bg.png)' },
        { title: 'Answered Calls', value: outgoingCallsData.answered_call, icon: <FaPhoneVolume />, bgColor: '#ff9800', backgroundImage: 'url(/path/to/answered-call-bg.png)' },
      ];

      //  data = [
      //   { title: 'Total Agents', value: '0', icon: <FaUser />, bgColor: '#4caf50', backgroundImage: 'url(/path/to/total-agents-bg.png)' },
      //   { title: 'AQT', value: '0', icon: <FaUsers />, bgColor: '#3f51b5', backgroundImage: 'url(/path/to/aqt-bg.png)' },
      //   { title: 'AHT', value: '0', icon: <FaStopwatch />, bgColor: '#f44336', backgroundImage: 'url(/path/to/aht-bg.png)' },
      //   { title: 'ASA', value: '00:00', icon: <FaHourglassHalf />, bgColor: '#ff9800', backgroundImage: 'url(/path/to/asa-bg.png)' },
      //   { title: 'Average Wrap-up', value: '00:00', icon: <FaClock />, bgColor: '#795548', backgroundImage: 'url(/path/to/avg-wrapup-bg.png)' },
      //   { title: 'SLA', value: '0%', icon: <FaPercentage />, bgColor: '#9c27b0', backgroundImage: 'url(/path/to/sla-bg.png)' },
      //   { title: 'Total Data', value: '0', icon: <FaDatabase />, bgColor: '#2196f3', backgroundImage: 'url(/path/to/total-data-bg.png)' },
      //   { title: 'Offered-Call', value: '0', icon: <FaPhoneAlt />, bgColor: '#ff5722', backgroundImage: 'url(/path/to/offered-call-bg.png)' },

      //   { title: 'Dialed Data', value: '0', icon: <FaDatabase />, bgColor: '#4caf50', backgroundImage: 'url(/path/to/dialed-data-bg.png)' },
      //   { title: 'Pending Data', value: '0', icon: <FaPhoneSquareAlt />, bgColor: '#03a9f4', backgroundImage: 'url(/path/to/pending-data-bg.png)' },
      //   { title: 'Pending Callbacks', value: '0', icon: <FaHourglassHalf />, bgColor: '#ff9800', backgroundImage: 'url(/path/to/pending-callback-bg.png)' },
      //   { title: 'Agent Disposed', value: '0', icon: <FaUser />, bgColor: '#4cabaf', backgroundImage: 'url(/path/to/system-disposed-bg.png)' },
      //   { title: 'System Disposed', value: '0', icon: <FaCog />, bgColor: '#f44336', backgroundImage: 'url(/path/to/system-disposed-bg.png)' },
      //   { title: 'Answered Calls', value: '00:00', icon: <FaPhone />, bgColor: '#4caf50', backgroundImage: 'url(/path/to/answered-call-bg.png)' },
      //   { title: 'Abandoned Calls', value: '0', icon: <FaPhoneSlash />, bgColor: '#f44336', backgroundImage: 'url(/path/to/abandoned-call-bg.png)' },
      //   { title: 'Dialed Calls', value: '0', icon: <FaPhone />, bgColor: '#4caf7e', backgroundImage: 'url(/path/to/dialed-call-bg.png)' },
      //   { title: 'Con.Dialed Calls', value: '0', icon: <FaPhoneVolume />, bgColor: '#ff9800', backgroundImage: 'url(/path/to/connected-dialed-call-bg.png)' },
      // ];
    }


    const filteredData = isSuperAdmin ? data : data.slice(0, data.length / 2);

    const graphData = [
      { status: 'Available', agents: agentDataObject.logged_in_agent },
      { status: 'Busy', agents: agentDataObject.agent_on_call },
      { status: 'Offline', agents: Number(agentDataObject.total_agent) - Number(agentDataObject.logged_in_agent) },
      // { status: 'Break', agents: 5 },
    ];

    const filteredGraphData = isSuperAdmin ? graphData : graphData.slice(0, 2);
    useSelector(SettingSelector.theme_color);

    const getVariableColor = () => {
      let prefix =
        getComputedStyle(document.body).getPropertyValue("--prefix") || "bs-";
      if (prefix) {
        prefix = prefix.trim();
      }
      const color1 = getComputedStyle(document.body).getPropertyValue(
        `--${prefix}primary`
      );
      const color2 = getComputedStyle(document.body).getPropertyValue(
        `--${prefix}info`
      );
      const color3 = getComputedStyle(document.body).getPropertyValue(
        `--${prefix}primary-tint-20`
      );
      const color4 = getComputedStyle(document.body).getPropertyValue(
        `--${prefix}warning`
      );
      return {
        primary: color1.trim(),
        info: color2.trim(),
        warning: color4.trim(),
        primary_light: color3.trim(),
      };
    };
    const variableColors = getVariableColor();

    const colors = [variableColors.primary, variableColors.info];
    useEffect(() => {
      return () => colors;
    });

    useEffect(() => {
      AOS.init({
        startEvent: "DOMContentLoaded",
        disable: function () {
          var maxWidth = 996;
          return window.innerWidth < maxWidth;
        },
        throttleDelay: 10,
        once: true,
        duration: 700,
        offset: 10,
      });
    });
    const chart1 = {
      options: {
        chart: {
          fontFamily:
            '"Inter", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
          toolbar: {
            show: false,
          },
          sparkline: {
            enabled: false,
          },
        },
        colors: colors,
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
          width: 3,
        },
        yaxis: {
          show: true,
          labels: {
            show: true,
            minWidth: 19,
            maxWidth: 19,
            style: {
              colors: "#8A92A6",
            },
            offsetX: -5,
          },
        },
        legend: {
          show: false,
        },
        xaxis: {
          labels: {
            minHeight: 22,
            maxHeight: 22,
            show: true,
            style: {
              colors: "#8A92A6",
            },
          },
          lines: {
            show: false, //or just here to disable only x axis grids
          },
          categories: ["Jan", "Feb", "Mar", "Apr", "Jun", "Jul", "Aug"],
        },
        grid: {
          show: false,
        },
        fill: {
          type: "gradient",
          gradient: {
            shade: "dark",
            type: "vertical",
            shadeIntensity: 0,
            gradientToColors: undefined, // optional, if not defined - uses the shades of same color in series
            inverseColors: true,
            opacityFrom: 0.4,
            opacityTo: 0.1,
            stops: [0, 50, 80],
            colors: colors,
          },
        },
        tooltip: {
          enabled: true,
        },
      },
      series: [
        {
          name: "total",
          data: [94, 80, 94, 80, 94, 80, 94],
        },
        {
          name: "pipline",
          data: [72, 60, 84, 60, 74, 60, 78],
        },
      ],
    };
    //chart2
    const chart2 = {
      options: {
        colors: colors,
        plotOptions: {
          radialBar: {
            hollow: {
              margin: 10,
              size: "50%",
            },
            track: {
              margin: 10,
              strokeWidth: "50%",
            },
            dataLabels: {
              show: false,
            },
          },
        },
        labels: ["Apples", "Oranges"],
      },
      series: [55, 75],
    };
    const chart3 = {
      options: {
        chart: {
          stacked: true,
          toolbar: {
            show: false,
          },
        },
        colors: colors,
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "28%",
            endingShape: "rounded",
            borderRadius: 5,
          },
        },
        legend: {
          show: false,
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          categories: ["S", "M", "T", "W", "T", "F", "S", "M", "T", "W"],
          labels: {
            minHeight: 20,
            maxHeight: 20,
            style: {
              colors: "#8A92A6",
            },
          },
        },
        yaxis: {
          title: {
            text: "",
          },
          labels: {
            minWidth: 19,
            maxWidth: 19,
            style: {
              colors: "#8A92A6",
            },
          },
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return "$ " + val + " thousands";
            },
          },
        },
      },
      series: [
        {
          name: "Successful deals",
          data: [30, 50, 35, 60, 40, 60, 60, 30, 50, 35],
        },
        {
          name: "Failed deals",
          data: [40, 50, 55, 50, 30, 80, 30, 40, 50, 55],
        },
      ],
    };

    const COLORS = ['#8884d8', '#82ca9d', '#ffc658', '#8884d8', '#82ca9d', '#ffc658'];

    const legendBox = (color) => ({
      display: "inline-block",
      width: "16px",
      height: "10px",
      backgroundColor: color,
      borderRadius: "2px",
      marginRight: "4px",
    });


    const isIncomingDataEmpty = doughnutIncomingData.datasets[0].data.every(val => val === 0);
    const isOutgoingDataEmpty = doughnutOutgoingData.datasets[0].data.every(val => val === 0);



    return (
      <Fragment>
        <h2 style={{ marginTop: "15px" }}>Analytics Dashboard</h2>
        {isSuperAdmin && <DashboardCampaignDetails />}
        {isSuperAdmin && <PendingPromptsTable />}
        {(isCallCenterAdmin || isSuperAdmin || isCompanyAdmin || isReseller) ? <>
          <div className="container-all">

            {/* Agents Section */}
            <div className="agent-container">
              <label className="form-label fw-bold fs-4 d-flex justify-content-between align-items-center">
                Agents
                {ToggleAgentPieChart ? (
                  <FaChartBar
                    onClick={() => {
                      setToggleAgentBarChart(true);
                      setToggleAgentPieChart(false);
                    }}
                    className="faChartBar"
                    size={28}
                  />
                ) : (
                  <FaChartPie
                    onClick={() => {
                      setToggleAgentBarChart(false);
                      setToggleAgentPieChart(true);
                    }}
                    className="faChartPie"
                    size={28}
                  />
                )}
              </label>

              <div className="legend-section">
                <div><span style={legendBox("#2ebf3f")} /> Total Agents</div>
                <div><span style={legendBox("#eb173b")} /> Logged in Agents</div>
                <div><span style={legendBox("#1761ebff")} /> Agents On Call</div>
              </div>

              <div className="chart-wrapper-agent">
                {ToggleAgentBarChart ? (
                  <Chart style={{marginTop:"100px"}} options={barAgentsData.options} series={barAgentsData.series} type="bar" height={250} />
                ) : (
                  <Doughnut data={doughnutAgentsData} options={doughnutOptions}  />
                )}
              </div>
            </div>

            {/* Calls Section */}
            <div className="call-container">
              <div className="dash-cal">
                <div className="calender-main">
                  <Calendar
                    value={startDate}
                    onChange={(e) => setStartDate(e.value)}
                    placeholder="Start Date"
                    dateFormat="yy-mm-dd"
                    showIcon
                    showButtonBar
                    className="calender"
                  />
                  <span className="mx-2">to</span>
                  <Calendar
                    value={endDate}
                    onChange={(e) => setEndDate(e.value)}
                    placeholder="End Date"
                    dateFormat="yy-mm-dd"
                    showIcon
                    showButtonBar
                    className="calender"
                  />
                  <Button label="Filter" onClick={handleFilter} className="filter" />
                </div>
              </div>

              <div className="inside-call-container">
                {/* Incoming */}
                <div className="chart-block">
                  <label className="form-label fw-bold fs-4 d-flex justify-content-between align-items-center">
                    Incoming
                    {ToggleincomingBarChart ? (
                      <FaChartPie  className="faChartPie" size={28} onClick={() => setToggleincomingBarChart(false)} />
                    ) : (
                      <FaChartBar  className="faChartBar" size={28} onClick={() => setToggleincomingBarChart(true)} />
                    )}
                  </label>

                  <div className="legend-section">
                    <div><span style={legendBox("#e45604ff")} /> Dialed Calls</div>
                    <div><span style={legendBox("rgba(53, 214, 220, 1)")} /> Answered Calls</div>
                    <div><span style={legendBox("rgb(156, 39, 176)")} /> Abandoned Calls</div>
                  </div>

                  <div className="chart-wrapper">
                    {ToggleincomingBarChart ? (
                      <Chart style={{marginTop:"192px"}} options={barIncomingData.options} series={barIncomingData.series} type="bar" height={200} />
                    ) : (
                      isIncomingDataEmpty ? (
                        <div className="chart-empty" >
                          <p style={{fontSize:"10px"}}>No Incoming Calls <FaPhoneAlt /></p>
                        </div>
                      ) : (
                        
                        <div style={{ width: "130px", height: "130px", marginTop: "70px" }}>
                        <Doughnut data={doughnutIncomingData} options={doughnutOptions} />
                        </div>
                      )
                    )}
                  </div>
                </div>

                {/* Outgoing */}
                <div className="chart-block">
                  <label className="form-label fw-bold fs-4 d-flex justify-content-between align-items-center">
                    Outgoing
                    {ToggleOutgoingBarChart ? (
                      <FaChartPie className="faChartPie" size={28} onClick={() => setToggleOutgoingBarChart(false)} />
                    ) : (
                      <FaChartBar className="faChartBar" size={28} onClick={() => setToggleOutgoingBarChart(true)} />
                    )}
                  </label>

                  <div className="legend-section">
                    <div><span style={legendBox("#f00054ff")} /> Total Calls</div>
                    <div><span style={legendBox("#d2cc1bff")} /> Dialed Calls</div>
                    <div><span style={legendBox("#28927bff")} /> Answered Calls</div>
                  </div>

                  <div className="chart-wrapper">
                    {ToggleOutgoingBarChart ? (
                      <Chart style={{marginTop:"155px"}} options={barOutgoingData.options} series={barOutgoingData.series} type="bar" height={200} />
                    ) : (
                      isOutgoingDataEmpty ? (
                        <div className="chart-empty">
                          <p style={{fontSize:"10px"}}>No Outgoing Calls <FaPhoneAlt /></p>
                        </div>
                      ) : (
                        <div style={{ width: "130px", height: "130px", marginTop: "70px" }}>
                        <Doughnut data={doughnutOutgoingData} options={doughnutOptions} />
                        </div>
                      )
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {
  isSuperAdmin && dashboardStats && (
    <div className="dashboard-container">
      <div className="dashboard-grid">

        <DashboardCard
          title="Total Sub Super Admin"
          value={dashboardStats?.users?.subSuperAdmin || "0"}
          icon={<FaUserShield />}
        />

        <DashboardCard
          title="Total Resellers"
          value={dashboardStats?.users?.reseller || "0"}
          icon={<FaUsers />}
        />

        <DashboardCard
          title="Total Company (User)"
          value={dashboardStats?.users?.companyAdmin || "0"}
          icon={<FaBuilding />}
        />

        <DashboardCard
          title="Total Call Centre (User)"
          value={dashboardStats?.users?.callCentreAdmin || "0"}
          icon={<FaUserTie />}
        />

        <DashboardCard
          title="Total Team Leads"
          value={dashboardStats?.users?.callCentreTeamLead || "0"}
          icon={<FaUserFriends />}
        />

        <DashboardCard
          title="Total Agents"
          value={dashboardStats?.users?.callCentreAgent || "0"}
          icon={<FaPhoneAlt />}
        />

        <DashboardCard
          title="Total Users (All)"
          value={dashboardStats?.users?.totalUsers || "0"}
          icon={<FaBullhorn />}
        />

        <DashboardCard
          title="Total Outbound Campaigns"
          value={dashboardStats?.campaigns?.totalCampaigns || "0"}
          icon={<FaBullhorn />}
        />

        <DashboardCard
          title="New Users This Month"
          value={dashboardStats?.users?.totalUsersThisMonth || "0"}
          icon={<FaBullhorn />}
          highlightValue={true}
        />

        <DashboardCard
          title="Outbound Camp This Month"
          value={dashboardStats?.campaigns?.totalCampaignsThisMonth || "0"}
          icon={<FaCalendarAlt />}
          highlightValue={true}
        />
      </div>
    </div>
  )
}

          <label className="form-label fw-bold fs-4 mb-1" style={{ marginTop: "30px" }}>Queue</label>
          <Row xs={1} md={2} lg={6} className="g-3">
            {queueData.map((item, idx) => (
              <Col key={idx}>
                <Card
                  className="shadow-sm"
                  style={{
                    borderRadius: '12px',
                    height: '100px',
                    position: 'relative',
                    overflow: 'hidden',
                    marginBottom: "10px",
                    borderBottom: `4px solid ${item.bgColor}`
                  }}
                >
                  {/* Background Icon */}
                  <div
                    style={{
                      position: 'absolute',
                      top: '50%',
                      right: '1%',
                      transform: 'translate(-50%, -50%)',
                      fontSize: '3rem',
                      color: 'rgba(0, 0, 0, 0.1)',
                      zIndex: 0,
                    }}
                  >
                    {item.icon}
                  </div>

                  <Card.Body
                    className="d-flex align-items-center p-2"
                    style={{ position: 'relative', zIndex: 1 }}
                  >
                    {/* Foreground Icon */}
                    <div style={{
                      backgroundColor: item.bgColor,
                      color: "white",
                      borderRadius: "50%",
                      width: "50px",
                      height: "50px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginRight: "10px",
                      flexShrink: 0,
                    }}>
                      {item.icon}
                    </div>

                    {/* Text Content */}
                    <div style={{ flexGrow: 1, textAlign: 'center' }}>
                      <Card.Title className="mb-0" style={{ fontSize: '1rem', fontWeight: '600' }}>
                        {item.title}
                      </Card.Title>
                      <Card.Text style={{ fontSize: '1.2rem', fontWeight: 'bold' }}>
                        {item.value}
                      </Card.Text>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
          <label className="form-label fw-bold fs-4 mb-3">Others</label>
          <Row xs={1} md={2} lg={6} className="g-3">
            {othersData.map((item, idx) => (
              <Col key={idx}>
                <Card
                  className="shadow-sm"
                  style={{
                    borderRadius: '12px',
                    height: '100px',
                    position: 'relative',
                    overflow: 'hidden',
                    marginBottom: "10px",
                    borderBottom: `4px solid ${item.bgColor}`
                  }}
                >
                  {/* Background Icon */}
                  <div
                    style={{
                      position: 'absolute',
                      top: '50%',
                      right: '1%',
                      transform: 'translate(-50%, -50%)',
                      fontSize: '3rem',
                      color: 'rgba(0, 0, 0, 0.1)',
                      zIndex: 0,
                    }}
                  >
                    {item.icon}
                  </div>

                  <Card.Body
                    className="d-flex align-items-center p-2"
                    style={{ position: 'relative', zIndex: 1 }}
                  >
                    {/* Foreground Icon */}
                    <div style={{
                      backgroundColor: item.bgColor,
                      color: "white",
                      borderRadius: "50%",
                      width: "50px",
                      height: "50px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginRight: "10px",
                      flexShrink: 0,
                    }}>
                      {item.icon}
                    </div>

                    {/* Text Content */}
                    <div style={{ flexGrow: 1, textAlign: 'center' }}>
                      <Card.Title className="mb-0" style={{ fontSize: '1rem', fontWeight: '600' }}>
                        {item.title}
                      </Card.Title>
                      <Card.Text style={{ fontSize: '1.2rem', fontWeight: 'bold' }}>
                        {item.value}
                      </Card.Text>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </>
          : isCallCenterAgent ? (
  //           <>
  //   <div className="container-all" >
  //     {/* Calls Section (only Outgoing for agent) */}
  //     <div className="call-container" style={{width:"100%"}}>
  //       <div className="dash-cal" >
  //         <div className="calender-main" >
  //           <Calendar
  //             value={AgentStartDate}
  //             onChange={(e) => setAgentStartDate(e.value)}
  //             placeholder="Start Date"
  //             dateFormat="yy-mm-dd"
  //             showIcon
  //             showButtonBar
  //             className="calender"
  //           />
  //           <span className="mx-2">to</span>
  //           <Calendar
  //             value={AgentEndDate}
  //             onChange={(e) => setAgentEndDate(e.value)}
  //             placeholder="End Date"
  //             dateFormat="yy-mm-dd"
  //             showIcon
  //             showButtonBar
  //             className="calender"
  //           />
  //           <Button
  //             label="Filter"
  //             onClick={handleAgentFilter}
  //             className="filter"
  //           />
  //         </div>
  //       </div>

  //       <div className="inside-call-container" style={{ width: "100%", display:"flex", justifyContent:"center"}}>
  //         {/* Outgoing only */}
  //         <div className="chart-block" style={{ width: "100%"}}>
  //           <label className="form-label fw-bold fs-4 d-flex justify-content-between align-items-center">
  //             Outgoing
  //             {ToggleOutgoingBarChart ? (
  //               <FaChartPie
  //                 className="faChartPie"
  //                 size={28}
  //                 onClick={() => setToggleOutgoingBarChart(false)}
  //               />
  //             ) : (
  //               <FaChartBar
  //                 className="faChartBar"
  //                 size={28}
  //                 onClick={() => setToggleOutgoingBarChart(true)}
  //               />
  //             )}
  //           </label>

  //           <div className="legend-section">
  //             <div><span style={legendBox("#f00054ff")} /> Total Calls</div>
  //             <div><span style={legendBox("#d2cc1bff")} /> Dialed Calls</div>
  //             <div><span style={legendBox("#28927bff")} /> Answered Calls</div>
  //           </div>

  //           <div className="chart-wrapper">
  //             {ToggleOutgoingBarChart ? (
  //               <Chart
  //                 style={{ marginTop: "155px" }}
  //                 options={barOutgoingData.options}
  //                 series={barOutgoingData.series}
  //                 type="bar"
  //                 height={200}
  //               />
  //             ) : (
  //               isOutgoingDataEmpty ? (
  //                 <div className="chart-empty">
  //                   <p style={{ fontSize: "11px" }}>No Outgoing Calls <FaPhoneAlt /></p>
  //                 </div>
  //               ) : (
  //                 <div style={{ width: "130px", height: "130px", marginTop: "70px" }}>
  //                   <Doughnut data={doughnutAgentOutgoingData} options={doughnutOptions} />
  //                 </div>
  //               )
  //             )}
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   </div>
  //   <DashboardButtons />
  //   <FloatingPanels />
  // </>
  <>
  

<div className="container-all" style={{ width: "100%" }}>
  {/* Calls Section (only Outgoing for agent) */}
  <div
    className="call-container"
    style={{
      width: "85%",           // bluish bg width – ends at Queues card
      display: "flex",
      flexDirection: "column",

      height: "100%",
    }}
  >
    {/* === TOP ROW: Filter (same width as graph) + Queues on right === */}
    <div
      className="dash-cal"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      {/* Filter block – same width as graph below */}
      <div
        className="calender-main"
        style={{
          flex: "0 0 70%",     // 70% width = graph width
          maxWidth: "67%",
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <Calendar
          value={AgentStartDate}
          onChange={(e) => setAgentStartDate(e.value)}
          placeholder="Start Date"
          dateFormat="yy-mm-dd"
          showIcon
          showButtonBar
          className="calender"
        />
        <span className="mx-2">to</span>
        <Calendar
          value={AgentEndDate}
          onChange={(e) => setAgentEndDate(e.value)}
          placeholder="End Date"
          dateFormat="yy-mm-dd"
          showIcon
          showButtonBar
          className="calender"
        />
        <Button
          label="Filter"
          onClick={handleAgentFilter}
          className="filter"
        />
      </div>

      {/* Queues card starts right after filter block */}
      {/* <div
        style={{
          paddingRight:"10px",
          paddingLeft:"20px",
          flex: "0 0 30%",
          maxWidth: "30%",
          display: "flex",
          justifyContent: "flex-end",
          position: "relative",
        }}
        onMouseEnter={() => setShowQueueTooltip(true)}
        onMouseLeave={() => setShowQueueTooltip(false)}
      >
        <Card
          className="shadow-sm"
          style={{
            borderRadius: "12px",
            height: "100px",
            position: "relative",
            overflow: "hidden",
            marginBottom: "10px",
            borderBottom: "4px solid #3f51b5",
            cursor: agentGroups.length > 0 ? "pointer" : "default",
            width: "200px",
          }}
        >
          <div
            style={{
              position: "absolute",
              top: "50%",
              right: "8px",
              transform: "translateY(-50%)",
              fontSize: "3rem",
              color: "rgba(0, 0, 0, 0.1)",
              zIndex: 0,
            }}
          >
            <FaUsers />
          </div>

          <Card.Body
            className="d-flex align-items-center p-2"
            style={{ position: "relative", zIndex: 1 }}
          >
            <div
              style={{
                backgroundColor: "#3f51b5",
                color: "white",
                borderRadius: "50%",
                width: "50px",
                height: "50px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginRight: "10px",
                flexShrink: 0,
              }}
            >
              <FaUsers />
            </div>

            <div style={{ flexGrow: 1, textAlign: "center" }}>
              <Card.Title
                className="mb-0"
                style={{ fontSize: "1rem", fontWeight: 600 }}
              >
                Queues
              </Card.Title>
              <Card.Text
                style={{ fontSize: "1.2rem", fontWeight: "bold" }}
              >
                {agentGroups.length}
              </Card.Text>
            </div>
          </Card.Body>
        </Card>

        {showQueueTooltip && agentGroups.length > 0 && (
          <div
            style={{
              position: "absolute",
              top: "110%",
              right: 0,
              marginTop: "8px",
              backgroundColor: "#fff",
              color: "#111",
              borderRadius: "8px",
              boxShadow: "0 16px 32px rgba(0,0,0,0.18)",
              padding: "12px",
              minWidth: "410px",
              zIndex: 9999,
              border: "1px solid rgba(0,0,0,0.07)",
            }}
            onMouseEnter={() => setShowQueueTooltip(true)}
            onMouseLeave={() => setShowQueueTooltip(false)}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 8,
                marginBottom: 6,
                borderBottom: "1px solid rgba(0,0,0,0.08)",
                paddingBottom: 4,
              }}
            >
              <div style={{ fontSize: "0.8rem", fontWeight: 600 }}>
                Assigned Groups
              </div>

              {agentGroups.length > pageSize && (
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <button
                    type="button"
                    aria-label="Previous"
                    onClick={(e) => {
                      e.stopPropagation();
                      setQueuePage((p) => Math.max(0, p - 1));
                    }}
                    disabled={!hasPrev}
                    style={{
                      border: "none",
                      background: "transparent",
                      opacity: hasPrev ? 1 : 0.4,
                      cursor: hasPrev ? "pointer" : "default",
                    }}
                  >
                    <FaChevronLeft />
                  </button>
                  <span style={{ fontSize: "0.75rem", color: "#555" }}>
                    {queuePage + 1}/{totalPages}
                  </span>
                  <button
                    type="button"
                    aria-label="Next"
                    onClick={(e) => {
                      e.stopPropagation();
                      setQueuePage((p) => Math.min(totalPages - 1, p + 1));
                    }}
                    disabled={!hasNext}
                    style={{
                      border: "none",
                      background: "transparent",
                      opacity: hasNext ? 1 : 0.4,
                      cursor: hasNext ? "pointer" : "default",
                    }}
                  >
                    <FaChevronRight />
                  </button>
                </div>
              )}
            </div>

            {paginatedGroups.map((grp, idx) => (
              <div
                key={`${grp.group_id || idx}-${queuePage}`}
                style={{
                  fontSize: "0.8rem",
                  lineHeight: 1.45,
                  padding: "6px 0",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "baseline",
                    gap: 15,
                    flexWrap: "wrap",
                  }}
                >
                  <span style={{ fontWeight: 600 }}>
                    {grp.group_name}
                  </span>
                  <span style={{ fontSize: "0.78rem", color: "#555" }}>
                    {grp.schedule?.start_time}-{grp.schedule?.end_time}
                  </span>
                </div>

                <div
                  style={{
                    fontSize: "0.74rem",
                    color: "#555",
                    marginTop: 2,
                  }}
                >
                  {Array.isArray(grp.schedule?.week_days)
                    ? grp.schedule.week_days.join(", ")
                    : ""}
                </div>
              </div>
            ))}
          </div>
        )}
      </div> */}
    </div>

    {/* === BOTTOM ROW: Outgoing graph (70% width, aligned with filter) === */}
    <div
      className="inside-call-container"
      style={{
        width: "70%",           // smaller graph width
        display: "flex",
        justifyContent: "center",
      }}
    >
      <div className="chart-block" style={{ width: "100%" }}>
        <label className="form-label fw-bold fs-4 d-flex justify-content-between align-items-center">
          Outgoing
          {ToggleOutgoingBarChart ? (
            <FaChartPie
              className="faChartPie"
              size={28}
              onClick={() => setToggleOutgoingBarChart(false)}
            />
          ) : (
            <FaChartBar
              className="faChartBar"
              size={28}
              onClick={() => setToggleOutgoingBarChart(true)}
            />
          )}
        </label>

        <div className="legend-section">
          <div>
            <span style={legendBox("#f00054ff")} /> Total Calls
          </div>
          <div>
            <span style={legendBox("#d2cc1bff")} /> Dialed Calls
          </div>
          <div>
            <span style={legendBox("#28927bff")} /> Answered Calls
          </div>
        </div>

        <div className="chart-wrapper">
          {ToggleOutgoingBarChart ? (
            <Chart
              style={{ marginTop: "155px" }}
              options={barOutgoingData.options}
              series={barOutgoingData.series}
              type="bar"
              height={200}
            />
          ) : isOutgoingDataEmpty ? (
            <div className="chart-empty">
              <p style={{ fontSize: "11px" }}>
                No Outgoing Calls <FaPhoneAlt />
              </p>
            </div>
          ) : (
            <div
              style={{
                width: "130px",
                height: "130px",
                marginTop: "70px",
              }}
            >
              <Doughnut
                data={doughnutAgentOutgoingData}
                options={doughnutOptions}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  </div>
</div>




    {/* floating controls for agent */}
    {/* <DashboardButtons />
    <FloatingPanels /> */}
  </>
          ) :
            <Row xs={1} md={2} lg={5} className="g-3">
              {data.map((item, idx) => (
                <Col key={idx}>
                  <Card
                    className="shadow-sm"
                    style={{
                      borderRadius: '12px',
                      height: '100px',
                      position: 'relative',
                      overflow: 'hidden',
                      marginBottom: "10px",
                      borderBottom: `4px solid ${item.bgColor}`
                    }}
                  >
                    {/* Background Icon */}
                    <div
                      style={{
                        position: 'absolute',
                        top: '50%',
                        right: '1%',
                        transform: 'translate(-50%, -50%)',
                        fontSize: '3rem',
                        color: 'rgba(0, 0, 0, 0.1)',
                        zIndex: 0,
                      }}
                    >
                      {item.icon}
                    </div>

                    <Card.Body
                      className="d-flex align-items-center p-2"
                      style={{ position: 'relative', zIndex: 1 }}
                    >
                      {/* Foreground Icon */}
                      <div style={{
                        backgroundColor: item.bgColor,
                        color: "white",
                        borderRadius: "50%",
                        width: "50px",
                        height: "50px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginRight: "10px",
                        flexShrink: 0,
                      }}>
                        {item.icon}
                      </div>

                      {/* Text Content */}
                      <div style={{ flexGrow: 1, textAlign: 'center' }}>
                        <Card.Title className="mb-0" style={{ fontSize: '1rem', fontWeight: '600' }}>
                          {item.title}
                        </Card.Title>
                        <Card.Text style={{ fontSize: '1.2rem', fontWeight: 'bold' }}>
                          {item.value}
                        </Card.Text>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
        }

        <Container className="my-4">
          {isCallCenterAgent ?
            (
              <>
                {/* <DashboardButtons /> */}
                <FloatingPanels />
              </>

            ) : (
              <Card>
                <Card.Header as="h5">Agent Status Distribution</Card.Header>
                <Card.Body>
                  <Row>
                    {/* Bar Chart */}
                    <Col md={6}>
                      <div style={{ height: '300px' }}>
                        <ResponsiveContainer width="100%" height="100%">
                          <BarChart
                            data={graphData}
                            margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                          >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="status" />
                            <YAxis />
                            <Tooltip />
                            <Legend />
                            <Bar dataKey="agents" name="Number of Agents">
                              {graphData.map((entry, index) => (
                                <Cell key={`bar-${index}`} fill={COLORS[index]} />
                              ))}
                            </Bar>
                          </BarChart>
                        </ResponsiveContainer>
                      </div>
                    </Col>

                    {/* Pie Chart */}
                    <Col md={6}>
                      <div style={{ height: '300px' }}>
                        <ResponsiveContainer width="100%" height="100%">
                          <PieChart>
                            <Pie
                              data={graphData}
                              dataKey="agents"
                              nameKey="status"
                              cx="50%"
                              cy="50%"
                              outerRadius={80}
                              label
                            >
                              {graphData.map((entry, index) => (
                                <Cell key={`pie-${index}`} fill={COLORS[index + 3]} />
                              ))}
                            </Pie>
                            <Tooltip />
                            <Legend />
                          </PieChart>
                        </ResponsiveContainer>
                      </div>
                    </Col>
                  </Row>

                </Card.Body>
              </Card>
            )}

        </Container>
      </Fragment>
    );
  })

  export default Index


const DashboardCard = ({ title, value, icon, highlightValue = false }) => {
  return (
    <div className="dashboard-card">
      {/* <div className="card-icon">{icon}</div> */}
      <div>
        <p style={{ fontSize: "12px" }}>{title}</p>
        <h4 style={{ marginTop: "-10px", fontSize: "28px", color: highlightValue ? "#00a63e" : "#000000" }}>{value}</h4>
      </div>
    </div>
  );
};